import type { ServicesApiEnvHealthAlert } from '@/services/api/services-api';

export const WORKSPACE_HEALTH_REFETCH_INTERVAL = 120_000;

export const DATA_ALERT_SEVERITY_RANK: Record<ServicesApiEnvHealthAlert['severity'], number> = {
  error: 0,
  caution: 1,
};
